<template>
	<div>
		<v-layout align-center justify-center class="dataLoading">
		<v-progress-circular
				indeterminate
				color="primary"
				v-show="loadingDetailData"
			></v-progress-circular>
		</v-layout>
		<v-data-table
			class="detailTable"
			:headers="computedHeadersDetail"
			:items="detailRowsInfoAndData.bookingRowsDetail"
			:items-per-page="detailRowsInfoAndData.detailRowsLength"
			fix-header
			hide-default-footer
			no-data-text="Oops. Something went wrong."
			v-show="showDetailTable"
		>
			<template v-slot:[`item.payment_method`]="{ item }">
					{{ item.payment_method }}
					{{ item.payment_cc_type | paymentDisplay }}
			</template>
			<template v-slot:[`item.quantity`]="{ item }">
				<v-chip :color="getColor(item.quantity)" dark>
					{{ item.quantity | toDecimal }}
				</v-chip>
			</template>
			<template v-slot:[`item.unit_price_incl_tax`]="{ item }">
				{{ item.unit_price_incl_tax,currencyFormat.locale,item.order_currency_code | toCurrency }}
			</template>
			<template v-slot:[`item.discount_amount`]="{ item }">
				{{ item.discount_amount, currencyFormat.locale, item.order_currency_code | toCurrency }}
			</template>
			<template v-slot:[`item.row_total_incl_tax`]="{ item }">
				{{ item.row_total_incl_tax,currencyFormat.locale,item.order_currency_code | toCurrency }}
			</template>
			<template v-slot:[`item.row_total_excl_discount`]="{ item }">
				<v-chip :color="getColor(item.row_total_excl_discount)" dark>
					{{ item.row_total_excl_discount, currencyFormat.locale,item.order_currency_code | toCurrency }}
				</v-chip>
			</template>
			<template v-slot:[`item.tax_percent`]="{ item }">
				{{ item.tax_percent | toDecimal }} %
			</template>
			<template v-slot:[`item.tax_amount`]="{ item }">
				{{ item.tax_amount, currencyFormat.locale, item.order_currency_code | toCurrency }}
			</template>
			<template v-slot:[`item.row_total_excl_tax`]="{ item }">
				{{ item.row_total_excl_tax, currencyFormat.locale, item.order_currency_code | toCurrency }}
			</template>
			<template v-slot:[`item.serviceprovider_commission_net`]="{ item }">
				{{ item.serviceprovider_commission_net, currencyFormat.locale, item.order_currency_code | toCurrency }}
			</template>
			<template v-slot:[`item.serviceprovider_comission`]="{ item }">
				{{ item.serviceprovider_comission | toDecimal }} %
			</template>
			<template v-slot:[`item.reseller_comission_amount`]="{ item }">
				{{ item.reseller_comission_amount, currencyFormat.locale, item.order_currency_code | toCurrency }}
			</template>
			<template v-slot:[`item.reseller_commission_percent`]="{ item }">
				{{ item.reseller_commission_percent | toDecimal }} %
			</template>
			<template v-slot:[`item.billingengine_order`]="{ item }">
				{{ item.billingengine_order | booleanToYesNo }}
			</template>
		</v-data-table>
	</div>
</template>

<script>
export default {
	props: ['detailRowsInfoAndData', 'loadingDetailData', 'currencyFormat', 'showDetailTable', 'billingEngineActivated'],
	data() {
		return {
			headersDetail: [
				{ text: 'Order date', value: 'order_date', selected: true },
				{
					text: 'Region Name',
					value: 'region_name',
					selected: true,
					hide: 'mdAndDown',
				},
				{
					text: 'Order ID',
					value: 'increment_id',
					selected: false,
				},
				{
					text: 'Validity start date',
					value: 'validity_start_date',
					hide: 'mdAndDown',
					selected: true,
				},
				{
					text: 'Payment',
					value: 'payment_method',
					hide: 'mdAndDown',
					selected: true,
				},
				{
					text: 'Qty.',
					value: 'quantity',
					selected: true,
					align: 'right',
				},
				{
					text: 'Unit price AVG',
					value: 'unit_price_incl_tax',
					hide: 'mdAndDown',
					selected: true,
					align: 'right',
				},
				{
					text: 'Price',
					value: 'row_total_incl_tax',
					selected: true,
					align: 'right',
				},
				{
					text: 'Discount',
					value: 'discount_amount',
					hide: 'mdAndDown',
					selected: true,
					align: 'right',
				},
				{
					text: 'Total gross',
					value: 'row_total_excl_discount',
					hide: 'mdAndDown',
					selected: true,
					align: 'right',
				},
				{
					text: 'Tax in %',
					value: 'tax_percent',
					hide: 'mdAndDown',
					selected: true,
					align: 'right',
				},
				{
					text: 'Tax amount',
					value: 'tax_amount',
					hide: 'mdAndDown',
					selected: true,
					align: 'right',
				},
				{
					text: 'Total Net',
					value: 'row_total_excl_tax',
					hide: 'mdAndDown',
					selected: true,
					align: 'right',
				},
				{
					text: 'SP Comm. in %',
					value: 'serviceprovider_comission',
					hide: 'mdAndDown',
					selected: true,
					align: 'right',
				},
				{
					text: 'SP Comm. Net',
					value: 'serviceprovider_commission_net',
					hide: 'mdAndDown',
					selected: true,
					align: 'right',
				},
				{
					text: 'Reseller',
					value: 'reseller_name',
					hide: 'mdAndDown',
					selected: true,
				},
				{
					text: 'Reseller Comm. in %',
					value: 'reseller_commission_percent',
					hide: 'mdAndDown',
					selected: true,
					align: 'right',
				},
				{
					text: 'Reseller Comm. Gross',
					value: 'reseller_comission_amount',
					hide: 'mdAndDown',
					selected: true,
					align: 'right',
				},
				{
					text: 'Billing engine order',
					value: 'billingengine_order',
					hide: 'mdAndDown',
					selected: true,
					align: 'right',
				},
			],
		}
	},
	methods: {
		getColor(value) {
			if (value > 0) return 'green'
			if (value < 0) return 'red'
			return 'orange'
		},
	},
	computed: {
		computedHeadersDetail() {
			return this.headersDetail.filter((h) => {
				if (h.value === 'billingengine_order') {
					return this.billingEngineActivated && (!h.hide || !this.$vuetify.breakpoint[h.hide])
				}
				return !h.hide || !this.$vuetify.breakpoint[h.hide]
			})
		},
	},
	filters: {
		toCurrency(amount, locale, currency) {
			const number = Number(amount)
			const formatter = new Intl.NumberFormat(locale, {
				style: 'currency',
				currency,
				minimumFractionDigits: 2,
			})
			return formatter.format(number)
		},
		toDecimal(value) {
			const number = parseFloat(value)
			const result = number.toFixed(2)
			return result
		},
		rowTotalExclComission(rowTotal, comission) {
			const rowTotalNum = Number(rowTotal)
			const comissionNum = Number(comission)
			return (rowTotalNum - comissionNum).toFixed(2)
		},
		paymentDisplay(creditCard) {
			let concattedCreditCard = ''
			if (creditCard != null) {
				concattedCreditCard = concattedCreditCard.concat(' - ', creditCard)
			}
			return concattedCreditCard
		},
		booleanToYesNo(value) {
			if (value === null) return 'info not available'
			return value ? 'Yes' : 'No'
		},
	},
};
</script>
<style scoped>
.detailTable {
	background-color: rgba(128, 128, 128, 0);
	padding-left: unset;
}

.v-data-table tbody tr.v-data-table__expanded__content {
	padding: unset;
}
</style>
